import React, { Component } from 'react';
import { connect } from 'react-redux'
import classnames from 'classnames';
import autobind from 'autobind-decorator'
import querystring from 'querystring'
import { closePopup } from '../../../actions/popup';
import { jsonResponseHandler } from '../../../utils/FetchHelper'
import Timer from '../../../utils/Timer'
import {addPrefix} from "../../../utils/UriUtil";

const STATUS_READY = 1
const STATUS_CHECK = 2
const STATUS_DUPLICATED = 3
const STATUS_VALIDATED = 4


@connect(state => ({
    isSkinSavePopupOpened: state.popup.isSkinSavePopupOpened,
    title: state.popup.title,
    callBack: state.popup.callBack,
    description: state.popup.description,
}), dispatch => ({
    handlePopupClose: () => {
        dispatch(closePopup())
    },
    dispatch
}))
class SkinSavePopup extends Component {
    constructor(props, context) {
        super(props, context)
        this.state = this.makeInitState()
		this.timer = new Timer(1000)
	}
	
    componentWillReceiveProps(nextProps) {
        if (nextProps.isSkinSavePopupOpened) {
			this.setState(this.makeInitState())
		}
	}
	
	makeInitState() {
		return {
			focus: false,
			archiveName: '',
			status: STATUS_READY
		}
	}

    @autobind
    onFocus() {
        this.setState({focus: true});
    }

    @autobind
    onBlur() {
        this.setState({focus: false});
    }

    @autobind
    handleSkinNameChange(e) {
        this.setState({
			archiveName: e.target.value,
			status: STATUS_READY
		})
		this.timer.set(this.checkArchiveNameAvailability)
	}
	
	@autobind
	checkArchiveNameAvailability() {
		const { dispatch } = this.props
		const { archiveName } = this.state
		if (!archiveName) {
			return
		}

		this.setState({ status: STATUS_CHECK })
		fetch(addPrefix("/manage/design/skin/checkArchiveNameAvailability.json?") + querystring.stringify({
			archiveName: archiveName
		}), {
            method: 'get',
            credentials: "include",
        })
            .then(jsonResponseHandler(dispatch))
            .then(r => r.json())
            .then(data => {
                if (data['DUPLICATED']) {
                    this.setState({ status: STATUS_DUPLICATED })
                } else {
					this.setState({ status: STATUS_VALIDATED })
                }})
			.catch(e => {
				console.error(e)
				alert("스킨 저장 이름이 겹치는지 확인 할 수 없습니다")
			})
	}

    @autobind
    handleSave() {
		const { status } = this.state
		if (status === STATUS_DUPLICATED && !confirm("같은 이름의 저장된 스킨이 있습니다.\n스킨을 덮어씌우겠습니까?")) {
			return
		}
        this.props.callBack(this.state.archiveName);
    }

    render() {
		const { title, description, handlePopupClose, isSkinSavePopupOpened } = this.props
		const { focus, archiveName, status } = this.state

		const enabled = status === STATUS_DUPLICATED || status === STATUS_VALIDATED

        return (
            <div className="blog_layer"  style={{position: 'fixed', top: '50%', marginTop: '-112px', display: isSkinSavePopupOpened?'block':'none'}}>
                <div className="inner_blog_layer inner_blog_layer1">
                    <form>
                        <div className="cont_layer">
                            <strong className="tit_popup">{title}</strong>
                            <label className="lab_tf">
                                <span className="txt_popup">스킨명</span>
                                <input ref={input => input && input.focus()} type="text" className={classnames({"tf_blog": true, "tf_on": focus})} value={archiveName} onBlur={this.onBlur} onFocus={this.onFocus} onChange={this.handleSkinNameChange} />
                            </label>
                            { status === STATUS_DUPLICATED &&
                                <p className="txt_required">같은 이름으로 저장된 스킨이 있습니다.</p>
							}
							{ status === STATUS_CHECK &&
                                <p className="txt_required">이름 확인 중...</p>
                            }
                            <p className="txt_etc txt_skin">{description}</p>
                        </div>
                        <div className="fld_btn">
                            <button type="button" className="btn_cancel" onClick={handlePopupClose}>취소</button>
                            <button type="button" className={classnames({"btn_default":true, "btn_off":!enabled})} onClick={this.handleSave}  disabled={!enabled}>확인</button>
                        </div>
                    </form>
                </div>
            </div>
        );
    }
}

export default SkinSavePopup;
